// extracted by mini-css-extract-plugin
export default {"colorDotSelector":"Y1RyUzWKHM1gejldAJYp"};